import { Injectable } from '@angular/core';
import { OnyxEvent } from '../models/event';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { EventStore } from './event.store';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { Observable } from 'rxjs/Observable';
import { DateRoomType } from '../models/date-room-type';
import { Response } from '@angular/http';

@Injectable()
export class OverviewHttpService {

  private eventUrl: string = this.environment.baseUrl + '/api/events';
  private selectedEvent: OnyxEvent;

  constructor(private http: AppAuthHttpService,
              private eventStore: EventStore,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
    eventStore.selectedEvent.map( event => this.selectedEvent = event);
  }

  getDateRoomTypeSummary(eventId: number): Observable<DateRoomType> {
    const reservationUrl = `${this.eventUrl}/${eventId}/overview/date-room-type-summary`;

    return this.http.get(reservationUrl)
      .map((res: Response) => res.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getDateRoomTypeSummaryByParty(eventId: number, eventPartyId: number): Observable<DateRoomType> {
    const reservationUrl = `${this.eventUrl}/${eventId}/${eventPartyId}/overview/date-room-type-summary`;

    return this.http.get(reservationUrl)
      .map((res: Response) => res.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/overview.http.service.ts